<template>
  <el-row class="BannerContWidth">
    <div>
      <!-- <div class="header">
        <p class="text">找回密码</p>
      </div> -->
      <!-- 密码为6至9位字母、数字组合 -->
      <div class="sendInfo">{{$t('login.setpasswordTip')}}</div>
      <el-input v-model="Password"
                type='password'
                clearable
                show-password
                @input="PasswordChange"
                @clear="clear ('PasswordTips')"
                :placeholder="$t('login.passwordplaceholder')"></el-input>
      <p class="passwordtips">{{ this.PasswordTips }}</p>
      <el-input v-model="rePassword"
                type='password'
                clearable
                show-password
                @input="rePasswordChange"
                @clear="clear ('rePasswordTips')"
                :placeholder="$t('login.resignPasswordConfirm')"></el-input>
      <p class="passwordtips">{{ this.rePasswordTips }}</p>
      <!-- <group class="inpBox">
      <x-input class="inpClass"
               v-model="Password"
               type="password"
               @on-change='PasswordChange'
               @on-click-clear-icon='clear("PasswordTips")'
               :placeholder="$t('setPassword.inpPassword')"></x-input>
      <p class="">{{ this.PasswordTips }}</p>
      <x-input class="inpClass"
               v-model="rePassword"
               type="password"
               @on-change='rePasswordChange'
               @on-click-clear-icon='clear("rePasswordTips")'
               :placeholder="$t('setPassword.rinpPassword')"></x-input>
      <p class="">{{ this.rePasswordTips }}</p>
    </group> -->
      <div>
        <!-- 确定 -->
        <el-button class="but-box"
                   type="danger"
                   @click="confirm()">{{$t('confirmText')}}</el-button>
        <!-- <el-button plain
                   type="primary"
                   :class="[btnact==false?'custom-primary act':'custom-primary']"
                   :disabled='btnact'
                   @click.native="confirm">确定</el-button> -->
      </div>
    </div>
    <login :Loginshow.sync="Loginshow"></login>
  </el-row>
</template>

<script>
import login from '@/components/login'
export default {
  components: {
    login
  },
  data () {
    return {
      token: '',
      Password: '',
      rePassword: '',
      PasswordTips: '',
      rePasswordTips: '',
      btnact: true,
      Loginshow: false
    }
  },
  created () {
    let screenWidth = document.body.clientWidth // body宽度
    let scrollWidth = window.innerWidth - document.body.clientWidth // 滚动条宽度
    if (screenWidth < 768) {
      this.IsShow = false
    } else {
      this.IsShow = true
    }
    window.onresize = () => {
      let screenWidth = document.body.clientWidth
      if (screenWidth + scrollWidth <= 768) {
        this.IsShow = false
        this.BannerHeight = '200'
      } else {
        this.IsShow = true
        this.BannerHeight = '400'
      }
    }

    let data = this.$route.query.token
    if (data) {
      this.token = data
    } else {
      // this.$layer.open({
      //   content: this.mylayerHtml('tipsHtml', this.$t('result.mailerror')),
      //   className: 'tips',
      //   shadeClose: false,
      //   btn: [this.$t('Confirm')],
      //   yes (index, $layer) {
      //     // 函数返回 false 可以阻止弹层自动关闭，需要手动关闭
      //     vm.$layer.closeAll();
      //     vm.$router.push({ path: '/signIn' });
      //   }
      // })
    }
  },
  methods: {
    PasswordChange (value) {
      // if (this.PasswordTips != '') {
      this.passwordVerification(value)
      // }
    },
    rePasswordChange (value) {
      // if (this.PasswordTips != '') {
      this.repasswordVerification(value)
      // }
    },
    passwordVerification (value) {//password校验
      let reg1 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,9}$/ // 6-9位数字字母混合正则验证
      if (value == '') {
        this.PasswordTips = this.$t('setPassword.pwdtipnull')//必填项，不能为空
        this.btnact = true
        return true
      } else {
        if (!reg1.test(value)) {
          this.PasswordTips = this.$t('setPassword.pwdtip')//'密码格式不正确（字母或数字，长度需为6-9）'
          this.btnact = true
          return true
        } else {
          this.PasswordTips = '';
          if (this.rePassword != '') {
            this.repasswordVerification(this.rePassword);
          };
          return false
        }
      }
    },
    repasswordVerification (value) {//password校验
      let reg1 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,9}$/ // 6-9位数字字母混合正则验证
      if (value == '') {
        this.rePasswordTips = this.$t('setPassword.pwdtipnull')//必填项，不能为空
        this.btnact = true
        return true
      } else {
        if (!reg1.test(value)) {
          this.rePasswordTips = this.$t('setPassword.pwdtip')//'密码格式不正确（字母或数字，长度需为6-9）'
          this.btnact = true
          return true
        } else if (value != this.Password) {
          this.rePasswordTips = this.$t('setPassword.rpwdtip')//两次密码需一致
          this.btnact = true
          return true
        } else {
          this.rePasswordTips = ''
          this.btnact = false
          return false
        }
      }
    },
    clear (val) {
      // 点击清空按钮后清空提示
      this[val] = ''
    },
    confirm () {
      if (this.passwordVerification(this.Password)) {
        return
      }
      if (this.repasswordVerification(this.rePassword)) {
        return
      }

      this.$axios.post(this.apiUrl.API.updatePwd, { loginPwd: this.rePassword, captchaFlowNo: this.token })
        .then((res) => {
          if (res.data.resCode === 'C502570000000') {
            this.$alert(vm.$t('reSetPassword.SetresignPasswordSuccessText'), {//密码修改成功,请登录
              confirmButtonText: vm.$t('confirmText'),//确定
              callback: action => {
                this.Loginshow = true;
                this.$router.push({ path: '/' });
              }
            });
          }
        })
    }
  },
  computed: {
    // Password: {
    //   get () {
    //     return this.$store.state.Password
    //   },
    //   set (value) {
    //     this.$store.commit('inputChange',{type:'Password',value:value})
    //   }
    // },
    // rePassword: {
    //   get () {
    //     return this.$store.state.rePassword
    //   },
    //   set (value) {
    //     this.$store.commit('inputChange',{type:'Password',value:value})
    //   }
    // }
  }
}
</script>

<style scoped>
.BannerContWidth {
  width: 1040px;
  display: flex;
  justify-content: center;
  margin-top: 1.667rem;
  margin: 20px auto 0 auto;
  padding: 20px 0 40px 0;
  background: #fff;
  text-align: center;
}
.sendInfo {
  margin: 0 0 20px 0;
}
.but-box {
  width: 100%;
  margin: 10px 0 0 0;
}
.passwordtips {
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #ff0000;
}
@media (max-width: 1200px) {
  .BannerContWidth {
    width: 88%;
  }
  .BannerTextCont {
    width: 100%;
    padding: 1.5rem 1.667rem;
  }
}
@media (max-width: 992px) {
  .BannerContWidth {
    width: 84%;
  }
  .BannerTextCont {
    width: 100%;
    padding: 1rem 1.667rem;
  }
}
@media (max-width: 768px) {
  .BannerContWidth {
    width: 82%;
  }
}
@media (max-width: 576px) {
  .BannerContWidth {
    width: 90%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reSetPassword.vue